export default {
  independentMarketing: {
    common: {
      requestFailed: 'فشل طلب الواجهة',
      hintSelect: 'يختار',
      hintInput: 'يدخل',
      submit: 'يُقدِّم',
      cancel: 'يلغي',
      confirm: 'نعم',
    },
    agreement: {
      title: 'اتفاقية تسجيل الوكيل المستقل لشركة Autel',
      nextBtn: 'التالي',
      getAgreementFailed: 'فشل الحصول على محتوى الاتفاقية.',
    },
    successPage: {
      title:
        '.لقد تم إرسال معلومات طلبك بنجاح وسيتم إرسال نتائج المراجعة إلى بريدك الإلكتروني $1 خلال 15 يوم عمل. يرجى التحقق من بريدك الوارد للحصول على مزيد من المعلومات',
      subTitle: '.العودة إلى الصفحة الرئيسية بعد $1 (ثانية)',
    },
    applyTitle: 'أنت تتقدم لتصبح تاجرًا مستقلاً لشركة Autel. الرجاء تعبئة البيانات التالية بدقة:',
    companyName: 'اسم الشركة',
    companyTax: 'VAT ID',
    userCountry: 'دولة',
    legalPerson: 'مستشار قانوني',
    contactEmail: 'تواصل بالبريد الاكتروني',
    contactEmailTips:
      '.سيكون عنوان البريد الإلكتروني هذا بمثابة جهة الاتصال الخاصة بك عبر البريد الإلكتروني لنتيجة المراجعة. بمجرد الموافقة على المراجعة، سيتم استخدامها أيضًا كاسم حساب تسجيل الدخول لنظام إدارة الوكيل المستقل',
    corporateIdentity: 'معرف المستشار القانوني',
    uploadTips: 'JPG، JPEG، PNG، PDF (لا يزيد حجمها عن 20 ميجابايت)',
    businessLicense: 'رخصة أعمال',
    emailErrorTips: '.أدخل بريدًا إلكترونيًا صالحًا',
    uploadPic: 'تحميل الصور',
    picMaxLimit: '.الحد الأقصى لحجم الصورة هو 20 ميغابايت. الرجاء التحديد مرة أخرى',
  },
};
